import { Injectable } from '@angular/core';
import { Base } from "./base";
import {
    Investor as T,
    InvestorBankData, InvestorFiscalData, InvestorAddress, InvestorFile, Unit, InvestorContact
} from '../Interfaces';

@Injectable()
export class Investor extends Base implements T {
    investor_id: number;
    id: number;
    individual_name?: string;
    corporate_name?: string;
    name: string;
    email: string;
    telephone: string;
    mobile: string;
    nationality: string;
    type: string;
    curp: string;
    dob?: Date | string;
    is_foreign?: boolean;
    check: boolean = false;
    constructor(json?: T,
        public units?: Unit[],
        public address?: InvestorAddress,
        public fiscal_address?: InvestorFiscalData,
        public bank_data?: InvestorBankData,
        public contacts?: InvestorContact[],
        public files?: InvestorFile[]
    ) {
        super(json);
        if (json && 'investor_id' in json) this.id = this.investor_id;
        if (this.type == "MORAL") this.name = this.corporate_name;
        else this.name = this.individual_name;
    }

    toString(): string {
        return this.name;
    }
    get displayType() {
        let display = {
            'MORAL': 'Moral',
            'FISICA': 'Física'
        };
        return display[this.type];
    }
    hasAddress() {
        return this.address && this.address.address_id;
    }
    hasFiscalAddress() {
        return this.fiscal_address != null && this.fiscal_address.fiscal_data_id;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/investor.ts